<template>
    <div class="blocks-section" v-if="colors.length > 0">
        <v-chip v-for="(color, i) in colors" :key="i" class="mr-1 mt-1" small :color="color" dark>
            {{ `${$tc('common.blocks', 1)} ${i + 1}` }}
        </v-chip>
    </div>
</template>

<script>
export default {
    name: "BlockFooter",
    props: {
        colors: {
            type: Array,
            default: () => []
        },
    },
    data() {
        return {
            //
        }
    },
}
</script>

<style scoped>

.blocks-section {
    position: fixed;
    bottom: 0;
    right: 0;
    padding: 8px 0 8px 8px;
    border-radius: 10px 0 0 0;
    border-top: 1px solid #e5e5e5;
    border-left: 1px solid #e5e5e5;
    box-shadow: 0 -5px 5px -5px #e5e5e5;
    z-index: 2;
    backdrop-filter: blur(6px);
    max-width: calc(100% - 68px);
}

</style>